export default function BrowseController() {

}